// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.cargasSolicitadasBlock.title': 'Cargas Solicitadas',
    'dashboard.cargasSolicitadasBlock.noDateTooltip': 'Cargas ativas sem data definida. Elas não entram em nenhum dia.',
    'dashboard.cargasSolicitadasBlock.noDateChip': '+{{count}} sem data',
    'dashboard.cargasSolicitadasBlock.emptyFiltered': 'Nenhuma carga para os filtros.',
    'dashboard.cargasSolicitadasBlock.emptyDate': 'Nada para esta data.',
    'dashboard.cargasSolicitadasBlock.noClient': 'Sem cliente',
    'dashboard.cargasSolicitadasBlock.noRegion': 'Sem região',
    'dashboard.cargasSolicitadasBlock.contract': 'Contrato {{number}}',
    'dashboard.cargasSolicitadasBlock.noNumber': 'sem número',
    'dashboard.cargasSolicitadasBlock.noContract': 'Sem contrato',
    'dashboard.cargasSolicitadasBlock.loadsOne': '{{count}} carga',
    'dashboard.cargasSolicitadasBlock.loadsOther': '{{count}} cargas',
  },
  en: {
    'dashboard.cargasSolicitadasBlock.title': 'Requested Loads',
    'dashboard.cargasSolicitadasBlock.noDateTooltip': 'Active loads with no set date. They are not counted in any day.',
    'dashboard.cargasSolicitadasBlock.noDateChip': '+{{count}} no date',
    'dashboard.cargasSolicitadasBlock.emptyFiltered': 'No loads for these filters.',
    'dashboard.cargasSolicitadasBlock.emptyDate': 'Nothing for this date.',
    'dashboard.cargasSolicitadasBlock.noClient': 'No customer',
    'dashboard.cargasSolicitadasBlock.noRegion': 'No region',
    'dashboard.cargasSolicitadasBlock.contract': 'Contract {{number}}',
    'dashboard.cargasSolicitadasBlock.noNumber': 'no number',
    'dashboard.cargasSolicitadasBlock.noContract': 'No contract',
    'dashboard.cargasSolicitadasBlock.loadsOne': '{{count}} load',
    'dashboard.cargasSolicitadasBlock.loadsOther': '{{count}} loads',
  },
  es: {
    'dashboard.cargasSolicitadasBlock.title': 'Cargas solicitadas',
    'dashboard.cargasSolicitadasBlock.noDateTooltip': 'Cargas activas sin fecha definida. No entran en ningún día.',
    'dashboard.cargasSolicitadasBlock.noDateChip': '+{{count}} sin fecha',
    'dashboard.cargasSolicitadasBlock.emptyFiltered': 'Ninguna carga para los filtros.',
    'dashboard.cargasSolicitadasBlock.emptyDate': 'Nada para esta fecha.',
    'dashboard.cargasSolicitadasBlock.noClient': 'Sin cliente',
    'dashboard.cargasSolicitadasBlock.noRegion': 'Sin región',
    'dashboard.cargasSolicitadasBlock.contract': 'Contrato {{number}}',
    'dashboard.cargasSolicitadasBlock.noNumber': 'sin número',
    'dashboard.cargasSolicitadasBlock.noContract': 'Sin contrato',
    'dashboard.cargasSolicitadasBlock.loadsOne': '{{count}} carga',
    'dashboard.cargasSolicitadasBlock.loadsOther': '{{count}} cargas',
  },
}
